import React from 'react';
import includes from 'lodash/includes';
import PropTypes from 'prop-types';

import Checkbox from '../../components/Checkbox';
import Form from '../../components/Form';
import './styles.css';

class UserSelector extends React.PureComponent {
  static propTypes = {
    selectedUserIds: PropTypes.array,
    users: PropTypes.array,
    onSelectionChange: PropTypes.func,
    prefix: PropTypes.string,
  };

  onContactNotificationChange = (e) => {
    const { name, checked } = e.target;
    const { selectedUserIds, onSelectionChange } = this.props;
    let updatedContactIdList;
    if (checked) {
      updatedContactIdList = [...selectedUserIds, name];
    } else {
      updatedContactIdList = selectedUserIds
        .filter((id) => id !== name);
    }
    onSelectionChange(updatedContactIdList);
  };

  renderCheckBoxField = (user) => {
    const { prefix, selectedUserIds } = this.props;
    const userName = user.name; // user.firstName+' '+user.lastName;
    const userSelected = includes(selectedUserIds, user.id);

    return (
      <Form.Field key={user.id}>
        <Checkbox
          data-cy="user-selector-checkbox"
          id={`${prefix}_${user.id}`}
          name={user.id}
          checked={userSelected}
          onChange={this.onContactNotificationChange}
          label={{
            htmlFor: `${prefix}_${user.id}`,
            children: userName,
          }}
        />
      </Form.Field>
    );
  };

  render() {
    const { users } = this.props;

    return (
      <Form.Group widths="equal" role="group" aria-labelledby="users-notif-group">
        <Form.Group grouped styleName="checkbox-group">
          {users.slice(0, Math.ceil(users.length / 2)).map(this.renderCheckBoxField)}
        </Form.Group>
        <Form.Group grouped styleName="checkbox-group">
          {users.slice(Math.ceil(users.length / 2)).map(this.renderCheckBoxField)}
        </Form.Group>
      </Form.Group>
    );
  }
}

export default UserSelector;
